<template>
  <BButton
    :variant="
      !!variant ? `outline-${variant}` : 'outline-gray-04 text-primary-dark'
    "
    class="app-button-outline"
    v-on="$listeners"
    :to="to"
    :href="href"
    :block="block"
  >
    <slot />
  </BButton>
</template>

<script lang="ts">
import { BButton } from "bootstrap-vue";
import { Component, Vue, Prop } from "vue-facing-decorator";

@Component({
  components: {
    // NOTE: bootstrap-vue のコンポーネントはグローバル登録されているため本来は定義不要だが
    // h() で利用する際（モーダル内にボタンを配置したいなど）にグローバルコンポーネントを自動解決してくれないため、ここで定義している
    BButton
  }
})
export default class AppButtonOutline extends Vue {
  @Prop({
    default: false,
    type: Boolean
  })
  block!: boolean;

  @Prop({
    required: false,
    default: null,
    type: Object
  })
  to!: object | null;

  @Prop({
    required: false,
    default: "",
    type: String
  })
  href!: string;

  @Prop({
    required: false,
    default: "",
    type: String
  })
  variant!: string;
}
</script>

<style lang="scss">
.app-button-outline {
  padding-top: 11px;
  padding-bottom: 11px;
  font-weight: 500;
  background-color: $white;
  border-radius: 8px;
}
</style>
